export class Question {
    public id: number
    public activity_test: number
    public type: string
    public sentence: string
    public options: string[]
    public solution: string
    public position: number

    constructor(id: number, activity_test: number, type: string, sentence: string, options: string[], solution: string, position: number) {
        this.id = id
        this.activity_test = activity_test
        this.type = type
        this.sentence = sentence
        this.options = options
        this.solution = solution
        this.position = position
    }
}